import { render } from "./Chart.vue?vue&type=template&id=07925ac2"
import script from "./Chart.vue?vue&type=script&lang=js"
export * from "./Chart.vue?vue&type=script&lang=js"

import exportComponent from "/opt/build/repo/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__